import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    changeOnTradeAndOrder: {
        status: 0,
        changeOnTrade: "N",
        changeOnOrderbook: "N",
    },
    orderUpdateSocketTrigger: null,
};
export const orderUpdate = createSlice({
    name: "order-updates",
    initialState: initialState,
    reducers: {
        setChangeOnOrder(state, action) {
            state.changeOnTradeAndOrder = action.payload;
        },
        orderUpdateSocketTrigger(state, action) {
            state.orderUpdateSocketTrigger = action.payload;
        },
    },
});
export const { setChangeOnOrder, orderUpdateSocketTrigger } = orderUpdate.actions;
export default orderUpdate.reducer;
